import { render, staticRenderFns } from "./shopAddDialog.vue?vue&type=template&id=585c9594"
import script from "./shopAddDialog.vue?vue&type=script&lang=js"
export * from "./shopAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports